<template>
  <div id="receipt">
    <el-card shadow="never" v-loading="loading" class="reciept-card">
      <div class="receipt-logo">
        <span class="img">
          <img width="100" height="80" src="http://blog.railroad.ng/wp-content/uploads/2018/09/nigeria-01-2.png"/>
          <img class="logo" width="200" height="75" src="http://blog.railroad.ng/wp-content/uploads/2018/09/railroad-08a-300x101.png"/>
        </span>
        <el-form>
          <div style="font-size: 10px">
            <em>No. A10 AY MAI KIFI PLAZA NA'IBAWA ZARIA ROAD OPP <br/>
              SA'ADATU RIMI COLLAGE OF EDUCATION, BESIDE TOLL GATE.
              <br/>
            </em>
            <b style="font-weight: bold">(RC:1522463) </b>
          </div>
        </el-form>
      </div>
      <div v-if="isValid">
        <div class="passenger-info">
            <div class="passenger-info-item">
              <div>Ticket ID:</div>
              <span>{{passengerInfo.transaction.ref}}</span>
            </div>
            <div class="passenger-info-item">
              <div>Fullname</div>

              <div>{{ passengerInfo.passenger.full_name }}</div>
            </div>
            <div class="passenger-info-item">
                <span>Email :</span>
              <span>{{ passengerInfo.passenger.email }}</span>
            </div>
            <div class="passenger-info-item">
              <div>Phone :</div>
              <span> +234 {{passengerInfo.passenger.tel_no}}</span>
            </div>
            <div class="passenger-info-item">
                <span>Travel Route :</span>
              <span>{{ passengerInfo.transaction.description }}</span>
            </div>
            <div class="passenger-info-item">
                <div>Departure Date :</div>
              <span>{{ passengerInfo.passenger.dep_date | cleanDate }}</span>
            </div>

             <div class="passenger-info-item">
                <div>Seat Numbers :</div>
              <span>{{ passengerInfo.passenger.seat_nos }}</span>
             </div>
             <div class="passenger-info-item">
                <div>Car Number:</div>
              <span>{{ passengerInfo.passenger.route_section }}</span>
             </div>
             <div class="passenger-info-item">
                <div>Amount Paid: </div>
              <span>{{ passengerInfo.transaction.amount | nairaSign }}</span>
            </div>
            <div class="passenger-info-item">
              <div>Buy Train Trip: </div>
              <span>{{ passengerInfo.passenger.include_train_trip ? 'YES': 'NO' }}</span>
            </div>
        </div>
      </div>
      <div v-else>
        <h1 class="h1">Cannot generate reciept</h1>
      </div>
      <br/>
      <div v-if="otherPassengers.length > 0">
        <div> <strong>Adults Included</strong> </div>
        <div class="receipt-title">
          <el-row>
            <el-col :span="18">
              <span>Passenger Name</span>
            </el-col>
            <el-col :span="6" class="no-col">
              <span>Gender</span>
            </el-col>
          </el-row>

        </div>
        <div class="receipt-item">
          <el-row v-for="(item, index) in otherPassengers" :key="index" style="margin-bottom: 10px;">
            <el-col :span="18">
              <span>{{ item.full_name }}</span>
            </el-col>
            <el-col :span="6" class="no-col">
              <span> {{item.gender}}</span>
            </el-col>
          </el-row>
        </div>
        <hr/>
      </div>

      <div class="footer--info">
        <div><strong>Thanks for your patronage</strong></div>
        <div>
        Payment is handled by a secured gateway powered by paystack
        </div>
        <br/>
        <div>
        Payment is non refundable, but transfereable within two weeks
        </div>
      </div>
    </el-card>
    <el-row v-show="isValid" class="button">
       <el-col :span="24">
        <el-button type="warning" @click="printReceipt()">Print Ticket</el-button>
      </el-col>
<el-col :span="24">
        <el-button type="text" @click="backToHome()">Buy another ticket</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { checkPassengerInfo } from '@/services/passenger'
export default {
  name: 'Print',
  data () {
    return {
      passengerInfo: {},
      isValid: false,
      loading: true,
      otherPassengers: []
    }
  },
  mounted () {
    this.verifyInfo()
  },
  methods: {
    printReceipt () {
      window.print()
    },

    backToHome () {
      this.$router.push('/')
    },

    verifyInfo () {
      const routeQuery = this.$route.query
      const queryParams = {
        ...routeQuery
      }
      checkPassengerInfo(queryParams)
        .then(res => {
          this.passengerInfo = res.data
          this.otherPassengers = res.data.passenger.others
          this.isValid = true
          this.loading = false
        })
        .catch(() => {
          this.isValid = false
          this.loading = false
          this.$notify.error({
            message: 'Error generating Ticket\nTry again'
          })
        })
    }
  }
}
</script>

<style src="./print.scss" lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/checkout/Print.vue